export default function SimpleLoader() {
  return (
    <>
      <div className="h-screen w-full grid place-items-center">
        <div className="w-full min-h-dvh grid place-items-center -mt-16">
          <div className="page-loader" />
        </div>
      </div>
    </>
  );
}

interface LoaderProps {
  message: React.ReactElement;
}

export function Loader(props: LoaderProps) {
  return (
    <>
      <div className="h-screen w-full grid place-items-center">
        <div className="w-full min-h-dvh grid place-items-center -mt-16">
          <div className="text-center flex flex-col items-center gap-4">
            <div className="page-loader" />
            {props?.message && <h5>{props?.message}</h5>}
          </div>
        </div>
      </div>
    </>
  );
}
